export const actions = {
  LOGIN_AUTH_TOKEN: 'LOGIN:AUTH_TOKEN',
  LOGIN_AUTH_TOKEN_OIDC: 'LOGIN:AUTH_TOKEN_IDP',
  LOGIN_FORGOT_PASSWORD: 'LOGIN:FORGOT_PASSWORD',
  LOGIN_RESET_PASSWORD: 'LOGIN:RESET_PASSWORD',
  LOGIN_IDP_CALLBACK: 'LOGIN:IDP_CALLBACK',
  LOGIN_VERIFY_2FA_CODE: 'LOGIN_VERIFY_2FA_CODE',
};

export enum TwoFactorValidationResult {
  UnexpectedError = -1,
  NotAllowed = 0,
  Valid = 1,
  IncorrectCode = 2,
  CodeExpired = 3,
}
